/* eslint-disable func-names */
/* globals define, DocMenus, DocNav, DocLang, DocCodeMenu, DocStyle, DocPopup, Helpers, MobileHelpers, Navigation */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery', 'jquery.cookie'], factory);
  } else {
    factory(jQuery);
  }
})(function ($) {
  const $body = $('body.page-documentation');
  if (!($body.length > 0)) {
    return;
  }
  // run only for documentation pages

  const $win = $(window);

  // Setup jump menu
  DocMenus.setupJumpMenu();
  // Roll over headers gives an anchor link with a #tag
  DocNav.setupAnchorLinksForHeaders();

  // Check which languages the page supports & if any
  // explicit languages are allowed
  DocLang.setupPermittedLanguages();

  // Find div, span, h6, p tags that support multiple lanages
  // and add unique attribute data-lang-content-group
  DocLang.groupLanguageSpecificContent($body);

  // Code blocks need to be wrapped in <div class="code-block-group" />
  // Needed for CSS to present the component
  // Also assign a unique code block ID for contiguous blocks of code
  // And then prepend a hidden code menu for each set of continguous blocks
  // that is used if the current language is not available in this block
  DocLang.wrapAndGroupCodeBlocks($body);

  // Set up the code menu slider events such as roll over, on click to change lang etc
  DocCodeMenu.setup($body, $win);

  // Set up the post it notes
  DocStyle.setupPostIt();

  // Set up definition lists
  DocStyle.setupDefinitionList();

  // Show the permitted languages in the nav if one or more langs are
  DocLang.setupLanguageNavigationMenu();

  // These will cause a re-render so do now
  DocStyle.setupDividerRings();
  DocStyle.setupBlueSeparator();
  DocStyle.setupInlineToc();

  // Scroll down/up popups when user is scrolling
  // Should be here because it confirms if API reference section exists
  DocPopup.setup();

  // Update the RHS Documentation menus to reflect current position
  // and enable open / close functionality
  DocMenus.openSectionOfCurrentPage();
  DocMenus.setupSectionClassToggleOnClick();

  Helpers.delay(50, function () {
    // If the language selected as absolutely no content on current page, we will
    // display everything as if user had selected Javascript. However, we will
    // not change the cookie so that the user will be able to navigate into other
    // pages with the language originally selected.
    let language = Helpers.getCurrentLanguage();
    if (!DocLang.languageAvailableOnPage(language)) {
      language = 'javascript';
    }
    DocCodeMenu.setLanguage(language, { persistToCookie: false });

    // reacalc header height since now a new header bar could be present
    const $header = $('[data-js-header]');
    let headerHeight = $header.outerHeight();

    // in case of page load was not on scrollTop or if the user has scrolled
    // before the docs content load, the header will be shrinked
    // this is caused because shrink event window is added before this exact file (common.js)
    // we need to increase calulated header height in order to have the correct offset
    // we could move order of the files but that could have undesired effects
    // the 14 is the shrink factor, i hate magic numbers as well but not seeing a better solution
    // for this at the time o writing

    if (MobileHelpers.usingMobileView()) {
      headerHeight += 10;
    } else if ($header.hasClass('header-wrap-collapsed')) {
      headerHeight += 14;
    }

    // If an anchor is contained in the link, navigate to the precise position
    // This is needed because we have fixed header, the anchor links don't always work as expected
    Navigation.options.offset = headerHeight;

    Navigation.scrollToAnchorOnLoad();
    // Take over the default anchor link behaviour due to the anchor names
    // ended up under the fixed header
    Navigation.setupScrollToAnchor({ anchors: DocNav.getDocLocalAnchors() });
    // readd data-local-nav anchors event based on the new offset caused by documentation content
    Navigation.setupScrollToAnchor({ anchors: $('[data-local-nav-menu] a[href*=\\#]') });
  });

  Helpers.delay(2000, () =>
    // If a timestamp exists in the demo, keep it live
    Helpers.enableLiveTimestamp(),
  );
});
